import { Badge } from "@mantine/core";
import "./StatusText.module.css";

const normStatusKey = (status) =>
  String(status || "").toUpperCase().replace(/\s+/g, "_");

const applyStyleMap = (styleMap, status) => {
  const style = styleMap[normStatusKey(status)] || {
    color: "#E4E4E4",
    textColor: "#697883",
  };
  return {
    color: style.color,
    textColor: style.textColor,
    displayText:
      status != null && status !== ""
        ? String(status).replace(/_/g, " ")
        : "Unknown",
  };
};

const FOLLOWUP_TYPE_STYLES = {
  OUTBOUND_CALL: { color: "#E7F0FF", textColor: "#0053A8" },
  WHATSAPP: { color: "#D1FFD9", textColor: "#24CB3F" },
  EMAIL: { color: "#F3E8FF", textColor: "#7C3AED" },
  PAYMENT_COLLECTION: { color: "#FFEDD1", textColor: "#FF8A00" },
  DOCUMENT_COLLECTION: { color: "#E8F4FD", textColor: "#1C7ED6" },
  IN_PERSON_MEETING: { color: "#D3F9F5", textColor: "#0C8599" },
  OTHER: { color: "#E4E4E4", textColor: "#697883" },
};

const PRIORITY_STYLES = {
  LOW: { color: "#D3F9F5", textColor: "#0C8599" },
  MEDIUM: { color: "#FFEDD1", textColor: "#E8590C" },
  HIGH: { color: "#FFE8CC", textColor: "#D9480F" },
  CRITICAL: { color: "#FFE1D8", textColor: "#EF4D57" },
};

const StatusText = ({ status, field }) => {
  let color = "";
  let displayText = "";
  let textColor = "";

  if (field === "is_expired") {
    color = status ? "#EF4D57" : "#3AC65E";
    displayText = status ? "Inactive" : "Active";
    textColor = status ? "#FFF" : "#FFF";
  } else if (field === "link_status") {
    color = status ? "#D1FFD9" : "#E4E4E4";
    displayText = status ? "Active" : "Expired";
    textColor = status ? "#24CB3F" : "#999999";
  } else if (field === "policy_status_traveller_wise") {
    if (status === "Active") {
      color = "#D1FFD9";
      displayText = "Active";
      textColor = "#24CB3F";
    } else if (status === "Matured") {
      color = "#FFEDD1";
      displayText = "Matured";
      textColor = "#FF8A00";
    } else if (status === "Inactive") {
      color = "gray";
      displayText = "In Active";
    } else if (status === "Pending") {
      color = "#FFEDD1";
      displayText = "Pending";
      textColor = "#FF8A00";
    } else if (status === "Expired") {
      color = "#FFE1D8";
      displayText = "Expired";
      textColor = "#FF8A00";
    }
  } else if (field === "followup_type") {
    ({ color, textColor, displayText } = applyStyleMap(FOLLOWUP_TYPE_STYLES, status));
  } else if (field === "priority") {
    ({ color, textColor, displayText } = applyStyleMap(PRIORITY_STYLES, status));
  } else if (field === "status") {
    const CRM_STATUS_STYLES = {
      NEW: { color: "#E7F0FF", textColor: "#0053A8" },
      CONTACTED: { color: "#E8F4FD", textColor: "#1C7ED6" },
      FOLLOW_UP: { color: "#FFF4E8", textColor: "#E8590C" },
      PROPOSAL_SENT: { color: "#F3E8FF", textColor: "#7C3AED" },
      NEGOTIATION: { color: "#FFEDD1", textColor: "#FF8A00" },
      CLOSED_WON: { color: "#D1FFD9", textColor: "#24CB3F" },
      CLOSED_LOST: { color: "#FFE1D8", textColor: "#EF4D57" },
      DRAFT: { color: "#E4E4E4", textColor: "#697883" },
      SENT: { color: "#E7F0FF", textColor: "#1C7ED6" },
      APPROVED: { color: "#D1FFD9", textColor: "#24CB3F" },
      REJECTED: { color: "#FFE1D8", textColor: "#EF4D57" },
      UPCOMING: { color: "#E7F0FF", textColor: "#0053A8" },
      DUE_TODAY: { color: "#FFEDD1", textColor: "#FF8A00" },
      OVERDUE: { color: "#FFE1D8", textColor: "#EF4D57" },
      DONE: { color: "#D1FFD9", textColor: "#24CB3F" },
      CANCELLED: { color: "#FFE1D8", textColor: "#EF4D57" },
      PENDING: { color: "#FFEDD1", textColor: "#FF8A00" },
      SCHEDULED: { color: "#FFF4E8", textColor: "#E8590C" },
      SUCCESS: { color: "#BBF7D0", textColor: "#15803D" },
    };
    ({ color, textColor, displayText } = applyStyleMap(CRM_STATUS_STYLES, status));
  } else {
    const key = typeof status === "string" ? status.toLowerCase() : status;
    switch (key) {
      case "completed":
      case "success":
        color = "#D1FFD9";
        displayText = "Success";
        textColor = "#24CB3F";
        break;
      case "pending":
        color = "#FFEDD1";
        displayText = "Pending";
        textColor = "#FF8A00";
        break;
      case "failed":
        color = "#FFE1D8";
        displayText = "Failed";
        textColor = "#EF4D57";
        break;
      case "inactive":
        color = "#E4E4E4";
        displayText = "Inactive";
        break;
      case "approved":
        color = "#D1FFD9";
        displayText = "Approved";
        textColor = "#24CB3F";
        break;
      case "cancel":
        color = "#FFE1D8";
        displayText = "Pending";
        break;
      case "cancelled":
        color = "#FAA0A0";
        displayText = "Cancelled";
        textColor = "#D22B2B";
        break;
      default:
        color = "#E4E4E4";
        textColor = "#697883";
        displayText =
          status != null && status !== ""
            ? String(status).replace(/_/g, " ")
            : "Unknown";
    }
  }

  return (
    <Badge
      radius={"4px"}
      fw={600}
      tt="capitalize"
      px={"md"}
      c={textColor}
      color={`${color}`}
    >
      {displayText}
    </Badge>
  );
};

export default StatusText;